__turbopack_context__.v({
  "background": "index-module-scss-module__ZvZ64q__background",
  "background_light": "index-module-scss-module__ZvZ64q__background_light",
  "body": "index-module-scss-module__ZvZ64q__body",
  "bottom": "index-module-scss-module__ZvZ64q__bottom",
  "bottom_light": "index-module-scss-module__ZvZ64q__bottom_light",
  "column": "index-module-scss-module__ZvZ64q__column",
  "desc": "index-module-scss-module__ZvZ64q__desc",
  "downloadIcons": "index-module-scss-module__ZvZ64q__downloadIcons",
  "downloadsLabel": "index-module-scss-module__ZvZ64q__downloadsLabel",
  "left": "index-module-scss-module__ZvZ64q__left",
  "license": "index-module-scss-module__ZvZ64q__license",
  "link": "index-module-scss-module__ZvZ64q__link",
  "links": "index-module-scss-module__ZvZ64q__links",
  "logo": "index-module-scss-module__ZvZ64q__logo",
  "logoWrapper": "index-module-scss-module__ZvZ64q__logoWrapper",
  "logo_light": "index-module-scss-module__ZvZ64q__logo_light",
  "mail": "index-module-scss-module__ZvZ64q__mail",
  "payment": "index-module-scss-module__ZvZ64q__payment",
  "paymentMethod": "index-module-scss-module__ZvZ64q__paymentMethod",
  "right": "index-module-scss-module__ZvZ64q__right",
  "root": "index-module-scss-module__ZvZ64q__root",
  "title": "index-module-scss-module__ZvZ64q__title",
  "top": "index-module-scss-module__ZvZ64q__top",
});
